import { Component } from '@angular/core';

@Component({
  selector: 'empathy-nps-description',
  templateUrl: 'nps-description.component.html',
  styleUrls: ['./nps-description.component.scss']
})
export class NPSDescriptionComponent {}
